<!-- Main Content Card -->
<div class="content-card">
  <div class="card-header">
    <h3 class="card-title">
      <svg>
        <use href="assets/icons.svg#package"></use>
      </svg>
      Select package
    </h3>
  </div>

  <div class="card-content">
    <div class="card-intro">
      <svg>
        <use href="assets/icons.svg#package"></use>
      </svg>
      <p>Choose the best broadband package for your customer</p>
    </div>

    <div class="packages-grid">
      @for (pkg of packages(); track pkg) {
        <div
          class="package-card"
          [class.selected]="selectedPackage?.tier === pkg.tier"
          (click)="selectPackage(pkg)"
        >
          <div class="package-header">
            <div class="package-icon">
              <svg>
                @switch (pkg.business) {
                  @case (false) {
                    @switch (pkg.tier) {
                      @case ('basic') {
                        <use href="assets/icons.svg#starter-connect"></use>
                      }
                      @case ('standard') {
                        <use href="assets/icons.svg#everyday-streaming"></use>
                      }
                      @case ('premium') {
                        <use href="assets/icons.svg#family-max"></use>
                      }
                      @case ('platinum') {
                        <use href="assets/icons.svg#home-gig"></use>
                      }
                      @case ('bonus') {
                        <use href="assets/icons.svg#infinity-home"></use>
                      }
                    }
                  }
                  @case (true) {
                    @switch (pkg.tier) {
                      @case ('basic') {
                        <use href="assets/icons.svg#starter-connect"></use>
                      }
                      @case ('standard') {
                        <use href="assets/icons.svg#growth-net"></use>
                      }
                      @case ('premium') {
                        <use href="assets/icons.svg#work-pro"></use>
                      }
                      @case ('platinum') {
                        <use href="assets/icons.svg#enterprise-pro"></use>
                      }
                      @case ('bonus') {
                        <use href="assets/icons.svg#infinity-biz"></use>
                      }
                    }
                  }
                }
              </svg>
            </div>
            <div class="package-title-section">
              <h4 class="package-name">{{ pkg.name }}</h4>
                @if (pkg.speed < 0) {
                  <span>Unlimited speed</span>
                }@else {
                  <span>{{ pkg.speed }} Mbps</span>
                }
            </div>
            @if (pkg.badge) {
              <span class="badge">{{ pkg.badge }}</span>
            }
          </div>
          <div class="package-pricing">
            <div class="price-box">
              <span class="price-amount">{{ pkg.price }}</span>
              <span class="price-period">per month</span>
            </div>
            <!-- <div class="installation-box"> -->
            <!--   <span class="installation-amount"> -->
            <!--     @switch (pkg.installation) { -->
            <!--       @case (0) { -->
            <!--         <span>FREE</span> -->
            <!--       } -->
            <!--       @default { -->
            <!--         <span>{{ pkg.installation }}</span> -->
            <!--       } -->
            <!--     } -->
            <!--   </span> -->
            <!--   <span class="installation-period">installation</span> -->
            <!-- </div> -->
          </div>
          <ul class="package-features">
            <span>{{ pkg.features }}</span>
            <!-- @for (feature of pkg.features; track feature) { -->
            <!--   <li> -->
            <!--     {{ feature }} -->
            <!--   </li> -->
            <!-- } -->
          </ul>
        </div>
      }
    </div>

    @if (selectedPackage) {
      <div class="selected-package">
        <h4>Order Summary</h4>
        <div>
          <p>Package:</p>
          <p>{{ selectedPackage.name }}</p>
          <p>Monthly cost:</p>
          <p>{{ selectedPackage.price }}</p>
          <p>Installation:</p>
        </div>
      </div>
    }

    <div class="discount-section">
      <label for="discount" class="discount-label">Discount (if applicable)</label>
      <input
        type="text"
        id="discount"
        class="discount-input"
        placeholder="Enter discount amount"
        [(ngModel)]="discount"
      />
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <button class="btn btn-secondary" type="button" (click)="goBack()">Back</button>
      <button
        class="btn btn-primary"
        type="button"
        [disabled]="!selectedPackage"
        (click)="goToCustomerDetails()"
      >
        Continue to Contract
      </button>
    </div>
  </div>
</div>
